import { Link } from 'react-router-dom';

import styled, { css, DefaultTheme } from 'styled-components';

import media from 'apps/auth/theme/media';

interface StackButtonProps {
    $isDisabled?: boolean;
}

type StackButtonTheme = DefaultTheme & {
    purple_8_tr: string;
    purple_16_tr: string;
};

const getTheme = (props: { theme: DefaultTheme }): StackButtonTheme => props.theme as StackButtonTheme;

const CommonCss = css<StackButtonProps>`
    display: flex;
    flex-direction: column;
    padding: 16px;
    border-radius: 12px;
    pointer-events: ${(props) => (props.$isDisabled ? 'none' : null)};

    &:hover,
    &:active {
        background: ${(props) => (props.$isDisabled ? 'none' : getTheme(props).purple_8_tr)};
    }

    ${media.desktop1920} {
        padding: 24px;
        border-radius: 16px;
    }
`;

export const StackButtonLink = styled.a<StackButtonProps>`
    ${CommonCss};
`;
export const StackButtonReactLink = styled(Link)<StackButtonProps>`
    ${CommonCss};
`;

interface ButtonIconProps {
    $isDisabled?: boolean;
}

export const ButtonIcon = styled.div<ButtonIconProps>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1px solid ${(props) => (props.$isDisabled ? getTheme(props).purple_16_tr : 'transparent')};
    background: ${(props) => (props.$isDisabled ? 'none' : getTheme(props).purple_8_tr)};
    margin-bottom: 8px;

    ${media.desktop1920} {
        margin-bottom: 16px;
    }
`;
